import { Navigate } from 'react-router-dom'

export default function Index() {
  return <Navigate to="/settings/referral-types/pms-referral" replace />
}
